import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { utils } from "../utils";


export const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        try {
            utils.web.localStorageSave("i18nLang", lng);
        }
        catch (err)
        {
            console.error("Failed to save language to localStorage:", err);
        }
        finally {
            i18n.changeLanguage(lng);
        }
    };

    const buttonStyle = {
        width: '120px', height: '32px', 
        margin: '4px', padding: '4px', 
        backgroundColor: '#fefefe', 
        color: '#121312',
        fontWeight: '500',
        border: '1px solid #766C76', borderRadius: '4px', 
        cursor: 'pointer', 
        '&:hover' : { 
            backgroundColor: '#efefef',
            borderColor: 'solidrgb(201, 77, 77)',
            fontWeight: '900',
        },
        '&:focus' : {
            backgroundColor: '#efefef',
            borderColor: 'solidrgb(201, 77, 77)',
            fontWeight: '500',
        }
    };

    return (
        <Box sx={{ '& button': { m:1 } }} >
            <div style={{ margin: '0 auto', width: '100%', padding: '20px', textAlign: 'center', alignItems: 'center', verticalAlign: 'center' }}>
                <Button onClick={() => changeLanguage('ko')} size="small" variant="contained" sx={buttonStyle}>
                    한국어
                </Button>
                <Button onClick={() => changeLanguage('en')} size="small" variant="contained" sx={buttonStyle}>
                    English
                </Button>
            </div>
        </Box>
    );
};

export default LanguageSelector;